import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecipientsSearchService {
  public constructor() {}
  // Observable string sources
  private searchRecipientData = new Subject<string>();

  // Observable string streams
  public searchData$ = this.searchRecipientData.asObservable();

  // Service message commands
  public getSearchedData(text: string): void {
    this.searchRecipientData.next(text);
  }
}
